import { ConnectIntegrationForm } from "../connect-integration-form"
import { use_connect_redirect_to } from "../use_connect_redirect_to"

// Vividly authenticates with an API token plus the UUID of the company it acts for — a token can
// serve more than one, so Vividly rejects a request that does not name one. The company id goes in
// the `username` field because it is the identifier of the connected account, which is what the
// integration row's `username` holds.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ConnectVividlyPage(props: any = {}) {
  const redirectTo = use_connect_redirect_to(props.redirectTo)

  return (
    <ConnectIntegrationForm
      integrationName="vividly"
      redirectTo={redirectTo}
      logoAlt="Vividly"
      description="Connect your Vividly TPM to sync promotions, products and customer pricing automatically, instead of uploading exports by hand."
      usernameLabel="Company ID"
      usernamePlaceholder="71aab36b-f3f1-4115-9fd3-cdefdd68ad15"
      passwordLabel="API Token">
      <div class="rounded-md bg-gray-50 border border-gray-200 p-4 text-sm text-gray-600 space-y-2">
        <p>
          In Vividly, go to <span class="font-medium">Account Settings → API Token</span> to generate a token. Your Vividly
          contact can give you the company ID.
        </p>
        <p>
          Promotions already uploaded from a Vividly CSV export are matched on their line key, so connecting this updates
          them rather than creating duplicates.
        </p>
      </div>
    </ConnectIntegrationForm>
  )
}
